import React from "react";
import MoneyRisePng from "../../../assets/MoneyRisePng.png";
import { MdInfo } from "react-icons/md";
import useWindowDimensions from "../../../helpers/Hooks/useWindowDimensions";
import UserTable from "./UserTable";

const Underwriting = ({ today }) => {
  const { height, width } = useWindowDimensions();

  return (
    <main>
      {/* Table 1 */}
      {/* <main className="mt-2 flex flex-col text-xs font-semibold">
        <section className="flex flex-grow items-center border rounded-t-md">
          <div className="tdTag_table3 text-blackText">Name :</div>
          <div className="tdTag_table3 font-medium text-greySecondary">
            Peter Parker
          </div>
        </section>
        <section className="flex flex-grow items-center border">
          <div className="tdTag_table3 text-blackText">SSN :</div>
          <div className="tdTag_table3 font-medium text-greySecondary">
            ### ### 2314
          </div>
        </section>
        <section className="flex flex-grow items-center border">
          <div className="tdTag_table3 text-blackText">Report date :</div>
          <div className="tdTag_table3 font-medium text-greySecondary">
            2023-01-15
          </div>
        </section>
      </main> */}
      {/* Akbarsha's table -------- code */}
      {/* <div className="my-2 overflow-hidden border border-border rounded-md">
        <table className="min-w-full">
          <tbody className="text-left">
            <tr className="border-b-[0.5px] border-border">
              <th
                scope="col"
                className="px-4 py-[11px] first-letter:w-[50%] text-xs font-semibold text-blackText"
              >
                Name :
              </th>
              <td className="px-4 py-[11px] whitespace-nowrap text-xs font-medium text-greySecondary ">
                Peter Parker
              </td>
            </tr>
            <tr className="border-b-[0.5px] border-border">
              <th
                scope="col"
                className="w-[50%] text-xs font-semibold text-blackText py-[11px] px-4"
              >
                SSN :
              </th>
              <td className="px-4 py-[11px] whitespace-nowrap text-xs font-medium text-greySecondary ">
                ### ### 2314
              </td>
            </tr>
            <tr className="">
              <th
                scope="col"
                className="w-[50%] text-xs font-semibold text-blackText py-[11px] px-4"
              >
                Report date :
              </th>
              <td className="px-4 py-[11px] whitespace-nowrap text-xs font-medium text-greySecondary ">
                {today}
              </td>
            </tr>
          </tbody>
        </table>
      </div> */}
      <UserTable />
      {/* <div className="flex flex-col">
        <div className="overflow-x-auto">
          <div className="py-2 inline-block min-w-full">
            <div className="overflow-hidden border border-border rounded p-0 m-0">
              <table className="min-w-full">
                <tbody className="text-left">
                  <tr className="border-b-[0.5px] border-border">
                    <th
                      scope="col"
                      className="px-4 py-[11px] text-xs font-semibold text-blackText"
                    >
                      Name :
                    </th>
                    <td className="pr-4 py-[11px] whitespace-nowrap text-xs font-medium text-greySecondary ">
                      {NameTable.Name}
                    </td>
                  </tr>
                  <tr className="border-b-[0.5px] border-border">
                    <th
                      scope="col"
                      className="w-[50%] text-xs font-semibold text-blackText py-[11px] px-4"
                    >
                      SSN :
                    </th>
                    <td className="pr-4 py-[11px] whitespace-nowrap text-xs font-medium text-greySecondary ">
                      {NameTable.SSN}
                    </td>
                  </tr>
                  <tr className="">
                    <th
                      scope="col"
                      className="w-[50%] text-xs font-semibold text-blackText py-[11px] px-4"
                    >
                      Report date :
                    </th>
                    <td className="pr-4 py-[11px] whitespace-nowrap text-xs font-medium text-greySecondary ">
                      {today}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div> */}

      <main
        className={`px-1 overflow-y-scroll`}
        style={{ height: `${height - 303}px` }}
      >
        {/* Money img */}
        <section className="mt-6 py-0 px-2 flex items-center rounded-md">
          <div className="flex items-center">
            <section className="mb-1 text-[50px] font-bold text-primary">
              10%
            </section>
            <section className="ml-4">
              <div className="w-full text-base font-semibold">
                Payment to income
              </div>
              <div className="w-full text-xs font-medium text-greySecondary">
                based on semi-monthly after-tax income and loan payments over
                the last three months
              </div>
            </section>
          </div>
        </section>

        <table className="mt-6 w-full text-sm text-left border-separate border-spacing-0">
          <thead className="w-full text-xs">
            <tr>
              <th colSpan={2}></th>
              {/* <th scope="col" colSpan={2} className="thTag text-center">
              Details
            </th> */}
              <th
                scope="col"
                className="thTag text-center font-semibold border-x border-t rounded-tl-md"
              >
                90 days
              </th>
              <th
                scope="col"
                className="thTag text-center font-semibold border-t border-r rounded-tr-md"
              >
                365 days
              </th>
            </tr>
          </thead>
          {/* 2, 3, 5 */}
          <tbody className="w-full text-xs font-medium">
            {/* Group 1 - Balance */}
            <tr className="">
              <td
                scope="row"
                rowSpan={2}
                className={`tdTag px-1 whitespace-nowrap font-semibold border-x border-y rounded-tl-md`}
              >
                Balance
              </td>
              <td className="tdTag px-1 border-y">
                Negative balance{width > 485 ? null : <br />} event count
              </td>
              <td
                className="tdTag px-0 text-center border-y border-x"
                id="tdValues"
              >
                43
              </td>
              <td
                className="tdTag px-0 text-center border-y border-r"
                id="tdValues"
              >
                115
              </td>
            </tr>
            <tr className="">
              <td className="tdTag px-1 border-b">
                Days since last{width > 485 ? null : <br />} negative balance
              </td>
              <td
                className="tdTag px-0 text-center border-x border-b"
                colSpan={2}
                id="tdValues"
              >
                8
              </td>
            </tr>
            {/* Group 2 - Behaviour */}
            <tr className="">
              <td
                scope="row"
                rowSpan={2}
                className="tdTag px-1 whitespace-nowrap font-semibold border-x border-b"
              >
                Behavior
              </td>
              <td className="tdTag px-1 border-b">
                Number of stop{width > 485 ? null : <br />} loan withdrawals
              </td>
              <td
                className="tdTag px-0 text-center border-x border-b"
                id="tdValues"
              >
                8
              </td>
              <td
                className="tdTag px-0 text-center border-x border-b"
                id="tdValues"
              >
                20
              </td>
            </tr>
            <tr className="">
              <td className="tdTag px-1 border-b">
                Number of{width > 485 ? null : <br />} NSF events
              </td>
              <td className="tdTag text-center border-x border-b" id="tdValues">
                29
              </td>
              <td className="tdTag text-center border-b border-r" id="tdValues">
                42
              </td>
            </tr>
            {/* <tr className="">
            <td className="tdTag border-b">
              Number of stop{width > 485 ? null : <br />} withdrawals
            </td>
            <td
              className="tdTag text-center border-x border-b"
              id="tdValues"
              colSpan={2}
            >
              0
            </td>
          </tr> */}
            {/* Group 3 - Additional Loan */}
            <tr className="">
              <td
                scope="row"
                rowSpan={6}
                className="tdTag px-1 whitespace-nowrap font-semibold border-x border-b rounded-bl-md"
              >
                Additional{width > 485 ? null : <br />} loans
              </td>
              <td className="tdTag px-1 border-b">
                Lenders with{width > 485 ? null : <br />} recent payments
              </td>
              <td className="tdTag text-center border-x border-b" id="tdValues">
                1
              </td>
              <td className="tdTag text-center border-b border-r" id="tdValues">
                3
              </td>
            </tr>
            <tr className="">
              <td className="tdTag px-1 border-b">
                Avg. semi-monthly{width > 485 ? null : <br />}loan payment
              </td>
              <td className="tdTag text-center border-x border-b" id="tdValues">
                $239.82
              </td>
              <td
                className="tdTag text-center border-b border-r rounded-br-md"
                id="tdValues"
              >
                $645.23
              </td>
            </tr>
            <tr className="">
              <td className="tdTag px-1 border-b">
                New loan{width > 485 ? null : <br />} deposit count
              </td>
              <td className="tdTag text-center border-x border-b" id="tdValues">
                3
              </td>
              <td className="tdTag text-center border-b border-r" id="tdValues">
                5
              </td>
            </tr>
            <tr className="">
              <td className="tdTag px-1 border-b">Total loan deposits</td>
              <td className="tdTag text-center border-x border-b" id="tdValues">
                $1,405.04
              </td>
              <td className="tdTag text-center border-b border-r" id="tdValues">
                $3,594.01
              </td>
            </tr>
            <tr className="">
              <td className="tdTag px-1 border-b">BNPL lenders</td>
              <td className="tdTag text-center border-x border-b" id="tdValues">
                0
              </td>
              <td className="tdTag text-center border-b border-r" id="tdValues">
                1
              </td>
            </tr>
            <tr className="">
              <td className="tdTag px-1 border-b">
                Avg. semi-monthly{width > 485 ? null : <br />} BNPL payment
              </td>
              <td className="tdTag text-center border-x border-b" id="tdValues">
                $0.00
              </td>
              <td className="tdTag text-center border-b border-r" id="tdValues">
                $38.46
              </td>
            </tr>
          </tbody>
        </table>
      </main>

      {/* <div className="relative"> */}
      {/* <main className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
        <section className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
          <div className="grid grid-cols-4 bg-red-400">
            <div className="col-span-2 bg-cyan-300">Details</div>
            <div className="">90 Days</div>
            <div className="">365 Days</div>
          </div>
        </section>
        <section className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
          <div className="grid grid-cols-4 bg-red-400">
            <div className="row-span-3 flex items-center justify-center bg-cyan-300">
              Balance
            </div>
            <section className="flex flex-col">
              <div className="">Negative balance event count</div>
              <div className="">Days since last negative balance</div>
            </section>

            <div className="">11</div>
            <div className="">10</div>
          </div>
        </section>
        {/* <section>
            <div className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
              <th
                scope="row"
                className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
              >
                Apple MacBook Pro 17"
              </th>
              <td className="px-6 py-4">Laptop</td>
              <td className="px-6 py-4">$2999</td>
            </div>
            <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
              <th
                scope="row"
                className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
              >
                Microsoft Surface Pro
              </th>
              <td className="px-6 py-4">Laptop PC</td>
              <td className="px-6 py-4">$1999</td>
            </tr>
          </section> 
      </main> */}
      {/* </div> */}

      {/* <main className="mt-6 flex">
        <section className="flex flex-grow flex-col font-medium border rounded-l-md">
          <div className="tdTag_table3 w-full text-sm font-semibold text-blackText border-b">
            Details
          </div>
          <div className="tdTag_table3 w-full text-sm text-blackText">
            Semi monthly
            <br />
            normalized income
          </div>
        </section>
        <section className="flex flex-col font-medium border">
          <div className="tdTag_table3 text-sm font-semibold text-blackText border-b">
            90 Days
          </div>
          <div className="tdTag_table3 text-sm font-medium text-greySecondary">
            $345
          </div>
        </section>
        <section className="flex flex-col font-medium border rounded-r-md">
          <div className="tdTag_table3 text-sm font-semibold text-blackText border-b">
            365 Days
          </div>
          <div className="tdTag_table3 text-sm font-medium text-greySecondary">
            $345
          </div>
        </section>
      </main>

      <main className="mt-6 flex flex-col text-sm text-blackText">
        <section className="flex flex-grow items-center font-medium border rounded-t-md">
          <div className="tdTag_table3 border-r">Primary Income Source</div>
          <div className="tdTag_table3">Manufacturing Inc</div>
        </section>
        <section className="flex flex-grow items-center font-medium border">
          <div className="tdTag_table3 border-r">Income period days</div>
          <div className="tdTag_table3">14</div>
        </section>
        <section className="flex flex-grow items-center font-medium border">
          <div className="tdTag_table3 border-r">
            Missing last expected income deposit
          </div>
          <div className="tdTag_table3">No</div>
        </section>
        <section className="flex flex-grow items-center font-medium border">
          <div className="tdTag_table3 border-r">
            Unemployment income detected
          </div>
          <div className="tdTag_table3">No</div>
        </section>
        <section className="flex flex-grow items-center font-medium border rounded-b-md">
          <div className="tdTag_table3 border-r">Social security income</div>
          <div className="tdTag_table3">No</div>
        </section>
      </main> */}

      {/* Warning MsgF */}
      {/* <section className="mt-7 py-4 px-4 flex bg-warningBg border border-warning rounded-md">
        <div className="iconCon">
          <MdInfo className="infoIcon" />
        </div>
        <div className="ml-4 text-xs font-medium">
          This customer report was prepared for a permissible purpose under the
          far Credit Report Act
        </div>
      </section> */}
    </main>
  );
};

export default Underwriting;
